/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespNullSearchResults_viewer$ref = any;
type SbRespRefineMenu_viewer$ref = any;
type SbRespSearchResultContainer_viewer$ref = any;
type TradePromo_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsComponents_viewer$ref: FragmentReference;
export type SbRespCollectionsComponents_viewer = {|
  +isSkyscraperAdEnabled: ?boolean,
  +isContentModuleEnabled: ?boolean,
  +isBillboardAdEnabled: ?boolean,
  +isThinPageEnabled: ?boolean,
  +isMoreWaysToBrowseEnabled: ?boolean,
  +$fragmentRefs: SbRespSearchResultContainer_viewer$ref & SbRespRefineMenu_viewer$ref & SbRespNullSearchResults_viewer$ref & TradePromo_viewer$ref,
  +$refType: SbRespCollectionsComponents_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "featureName",
    "value": "NON_MVP_SEARCH_BROWSE",
    "type": "String!"
  }
];
return {
  "kind": "Fragment",
  "name": "SbRespCollectionsComponents_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isSkyscraperAdEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isContentModuleEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "BROWSE_CONTENT_MODULES",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isBillboardAdEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isThinPageEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isMoreWaysToBrowseEnabled",
      "name": "isEnabledByLocale",
      "args": (v0/*: any*/),
      "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_viewer",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_viewer",
          "args": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f0d2da77e06c3177022d9af46989eed1';
module.exports = node;
